<template>
    <div class="form-footer">
        <unavailable-cta>
            This space is currently unavailable
        </unavailable-cta>

        <div class="space-preview">
            <p>This space is currently being reviewed. Please check back soon to see if it has become available!</p>
        </div>

        <unavailable-buttons v-if="ownsSpace && !isRemoved" :space-id="spaceId" :is-complete="true" />
    </div>
</template>

<script>
    import UnavailableCta from '../UnavailableCta';
    import UnavailableButtons from '../UnavailableButtons';

    export default {
        name: 'form-footer',

        components: { UnavailableCta, UnavailableButtons },

        props: {
            spaceId: {
                type: [String, Number],
                default: null,
            },
            ownsSpace: {
                type: Boolean,
                default: false,
            },
            isRemoved: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style lang="less" scoped>
    .form-footer {
        text-align: center;
        margin-top: 15px;
        margin-bottom: 5px;
        padding: 0;
        font-size: 0.9em;
        p {
            &:last-child {
                margin: 0;
            }
            > * {
                display: inline-block;
                vertical-align: middle;
            }
        }
    }
    /deep/ .unavailable-header {
        padding: 12px 10px 17px 10px;
        margin-bottom: 10px;
    }
    /deep/ .unavailable-buttons {
        margin-top: 10px;
    }
</style>
